import { createAsyncTypes } from 'utils/ActionCreator'
import { URL_CONST } from 'utils/urlConsts'

export const REPORT_ID_SET = 'ResolutionCenter/AffMailboxesDetail/REPORT_ID_SET'
export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST',
  'ResolutionCenterCenter/AffMailboxesDetail'
)
export const DOWNLOAD_CSV_REQUEST = createAsyncTypes(
  'DOWNLOAD_CSV_REQUEST',
  'ResolutionCenterCenter/AffMailboxesDetail'
)

export const SEARCH_CHANGE = 'ResolutionCenter/AffMailboxesDetail/SEARCH_CHANGE'
export const SEARCH_RESET = 'ResolutionCenter/AffMailboxesDetail/SEARCH_RESET'
export const PAGINATE_CHANGE = 'ResolutionCenter/AffMailboxesDetail/PAGINATE_CHANGE'

export const SENDER_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/SENDER_FILTER_CHANGE'
export const SUBJECT_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/SUBJECT_FILTER_CHANGE'
export const MAILBOX_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/MAILBOX_FILTER_CHANGE'
export const IPS_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/IPS_FILTER_CHANGE'
export const JUNK_MAIL_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/JUNK_MAIL_FILTER_CHANGE'

export const ATTACHMENTS_AND_LINKS_FILTER_CHANGE =
  'ResolutionCenter/AffMailboxesDetail/ATTACHMENTS_AND_LINKS_FILTER_CHANGE'
export const NOT_FOUND_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/NOT_FOUND_FILTER_CHANGE'
export const IS_READ_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/IS_READ_FILTER_CHANGE'
export const END_USERS_FILTER_CHANGE = 'ResolutionCenter/AffMailboxesDetail/END_USERS_FILTER_CHANGE'
export const SELECT_TOGGLE = 'ResolutionCenter/AffMailboxesDetail/SELECT_TOGGLE'
export const ACTIVATE_SELECT_ALL = 'ResolutionCenter/AffMailboxesDetail/ACTIVATE_SELECT_ALL'

export const CLUSTER_UNDO_ASYNC = createAsyncTypes(
  'CLUSTER_UNDO_ASYNC',
  'ResolutionCenter/AffMailboxesDetail'
)

export const REVERT_BACK_TO_ORIGIN_ASYNC = createAsyncTypes(
  'REVERT_BACK_TO_ORIGIN_ASYNC',
  'ResolutionCenter/AffMailboxesDetail'
)

export const CLUSTER_UNDO_MODAL_CLOSE =
  'ResolutionCenter/AffMailboxesDetail/CLUSTER_UNDO_MODAL_CLOSE'

export const STOP_REMEDIATION_ASYNC = createAsyncTypes(
  'STOP_REMEDIATION_ASYNC',
  'ResolutionCenter/AffMailboxesDetail'
)

export const DOWNLOAD_EMAIL_ASYNC = createAsyncTypes(
  'DOWNLOAD_EMAIL_ASYNC',
  'ResolutionCenter/AffMailboxesDetail'
)

export const SORT_PROPERTY_CHANGE = 'ResolutionCenter/AffMailboxesDetail/SORT_PROPERTY_CHANGE'

export const TOGGLE_RELEASE_FILTER = 'ResolutionCenter/AffMailboxesDetail/TOGGLE_RELEASE_FILTER'

const MAILBOX_STATUS_NOT_FOUND = 3
const STATUS_TEMP_ERROR = 4
const STATUS_ERROR = 5
const STATUS_IN_RECOVERABLE_ITEMS_FOLDER = 6
const STATUS_NOT_IN_QUARANTINE_OR_JUNK_FOLDER = 7

export const MAILBOX_ERROR_STATUSES = [
  MAILBOX_STATUS_NOT_FOUND,
  STATUS_TEMP_ERROR,
  STATUS_ERROR,
  STATUS_IN_RECOVERABLE_ITEMS_FOLDER,
  STATUS_NOT_IN_QUARANTINE_OR_JUNK_FOLDER,
]

export const MAX_MAILBOXES_CONST = 3

export const JUNK_MAIL_OPTIONS = [
  { value: 1, label: 'Found in Inbox' },
  { value: 2, label: 'Found in Junk Folder' },
  { value: 3, label: 'Found in Deleted Items' },
  { value: 4, label: 'Found in Other Folder' },
  { value: 0, label: 'Unknown' },
]

export const ATTACHMENTS_LINKS_OPTIONS = [
  { value: 0, label: 'All' },
  { value: 1, label: 'Incl. attachments' },
  { value: 2, label: 'Incl. links' },
  { value: 3, label: 'Incl. attachments & links' },
]

export const getSuccessToastMessage = (data, isReclassify) => (
  <span>
    {data?.count === 1 ? 'The email was ' : 'The emails were '}
    {isReclassify ? (
      <>
        marked as
        <strong>{` ${data?.newState} `}</strong>
        and will be shown in
      </>
    ) : (
      <>successfully reverted back to origin incident</>
    )}
    <a
      className="white cp b"
      href={`${URL_CONST.incidents.attackdetails}/${data.report_id}`}
      target="_blank"
      rel="noopener noreferrer"
      id="affmailboxes_details_report_id_link"
    >
      {` IS-${data?.report_id} `}
    </a>
  </span>
)
